"use client";

import { Switch as BaseSwitch } from "@base-ui/react/switch";

type Props = {
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
};

function SwitchRoot({
  checked,
  defaultChecked,
  onCheckedChange,
  disabled,
  className,
}: Props) {
  return (
    <BaseSwitch.Root
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={`relative flex h-6 w-10 shrink-0 cursor-default items-center rounded-full bg-disabled p-0.5 outline-none transition-colors data-checked:bg-primary data-disabled:opacity-40 ${className ?? ""}`}
    >
      <BaseSwitch.Thumb className="block size-5 rounded-full bg-surface shadow-sm transition-transform data-checked:translate-x-4" />
    </BaseSwitch.Root>
  );
}

export const Switch = {
  Root: SwitchRoot,
};
